import { ConsoleInstrumentation, Faro, getWebInstrumentations, initializeFaro as initialize } from '@grafana/faro-react'

const initializeFaro: (grafanaFaroCollectorURL: string, environment: string) => Faro = (
  grafanaFaroCollectorURL: string,
  environment: string
): Faro => {
  return initialize({
    url: grafanaFaroCollectorURL,
    app: {
      name: 'crunch',
      version: '1.0.0',
      environment: environment
    },
    sessionTracking: {
      samplingRate: environment === 'production' ? 0.01 : 1
    },
    instrumentations: [...getWebInstrumentations(), new ConsoleInstrumentation()]
  })
}

export default initializeFaro
